import React from 'react';
import ReactDOM from 'react-dom';
import GA4React from 'ga-4-react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from '@sentry/react';
import {Integrations} from '@sentry/tracing';
import env from 'react-dotenv';
import {ENV_PROD} from './utils/constants';
import 'bootstrap/dist/css/bootstrap.min.css';

// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
const ga4react = new GA4React(env.TRACKING_ID);
ga4react.initialize().then().catch()

if (env.NODE_ENV === ENV_PROD) {
  Sentry.init({
    dsn: env.SENTRY_DSN,
    integrations: [new Integrations.BrowserTracing() ],
    tracesSampleRate: 1.0,
  });
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
